import React from "react";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  appearance: ButtonAppearance;
  variant: ButtonVariant;
  size?: ButtonSize;
  isFullWidth?: boolean;
}

export type ButtonAppearance = "general" | "destructive" | "invert";

export type ButtonVariant = "primary" | "secondary" | "ghost";

export enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large"
}
